export const cleanString = (str: string) => str.replace(/^"|"$/g, '')
